import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const url = new URL(window.location.href);

    // Check for error in hash (otp_expired, access_denied, etc.)
    const hashParams = new URLSearchParams(url.hash.slice(1));
    const hashError = hashParams.get('error_description');
    if (hashError) {
      setError(decodeURIComponent(hashError));
      return;
    }

    // PKCE: exchange code for session
    const code = url.searchParams.get('code');
    if (code) {
      void supabase.auth.exchangeCodeForSession(code).then(({ error: err }) => {
        if (err) {
          setError(err.message);
        } else {
          navigate('/', { replace: true });
        }
      });
      return;
    }

    // Implicit: Supabase detectSessionInUrl handles it; just redirect
    navigate('/', { replace: true });
  }, [navigate]);

  const S = {
    page: {
      minHeight: '100dvh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'var(--bg-base)',
      flexDirection: 'column' as const,
      gap: 16,
      fontFamily: 'var(--font-sans)',
    },
    text: { fontSize: 14, color: 'var(--text-muted)' },
    link: { color: 'var(--accent)', textDecoration: 'none', fontWeight: 500 },
    errorBox: {
      padding: '16px 20px',
      borderRadius: 10,
      backgroundColor: 'oklch(22% 0.06 22)',
      border: '1px solid oklch(35% 0.1 22)',
      color: 'oklch(70% 0.18 22)',
      fontSize: 14,
      maxWidth: 360,
      textAlign: 'center' as const,
    },
  };

  if (error) {
    return (
      <div style={S.page}>
        <div style={S.errorBox}>{error}</div>
        <a href="/auth" style={S.link}>← Back to Sign In</a>
      </div>
    );
  }

  return (
    <div style={S.page}>
      <span style={S.text}>Signing you in…</span>
    </div>
  );
}
